<script lang="ts">
	import ButtonBoxPrimary from '$lib/elements/buttons/variants/ButtonBoxPrimary.svelte';

	export let numberOfSelectedFilters = 0;
</script>

<ButtonBoxPrimary
	props={{
		label: '',
		iconRight: 'slider',
		roundedFull: true
	}}
	on:click
>
	<div class="{numberOfSelectedFilters === 0 ? 'hidden' : ''} ml-2 md:ml-4 text-white">
		{numberOfSelectedFilters}
	</div>
</ButtonBoxPrimary>
